import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const EMPTY = { datasheets: [], missing: [] };
const ver = (ts) => (ts || "").replace(/\D/g, "").slice(0, 14);

// WP: Datenblätter zum gewählten Paket + zu einzeln hinzugefügten Komponenten.
export function useWpDatasheets(packageId, lines) {
  const compKey = (lines || []).map((l) => l.source_component_id).filter(Boolean).sort().join(",");
  const [info, setInfo] = useState(EMPTY);
  useEffect(() => {
    if (!packageId && !compKey) { setInfo(EMPTY); return undefined; }
    let alive = true;
    api.get("/datasheets/wp", { params: { package_id: packageId || undefined, component_ids: compKey } })
      .then((r) => alive && setInfo(r.data || EMPTY))
      .catch(() => alive && setInfo(EMPTY));
    return () => { alive = false; };
  }, [packageId, compKey]);
  return info;
}

const label = (c) => {
  const b = (c.brand || "").trim();
  const m = (c.model || "").trim();
  return b && m.toLowerCase().startsWith(b.toLowerCase()) ? m : `${b} ${m}`.trim();
};

// PV: Datenblätter der aktuell ausgewählten Katalog-Komponenten.
export function usePvDatasheets(items, catalog) {
  return useMemo(() => {
    const byId = Object.fromEntries((catalog || []).map((c) => [c.id, c]));
    const comps = (items || []).filter((it) => !it.is_free).map((it) => byId[it.component_id]).filter(Boolean);
    const datasheets = comps.filter((c) => c.datasheet_storage_path).map((c) => ({
      component_id: c.id,
      title: label(c),
      filename: c.datasheet_filename || "Datenblatt.pdf",
      size_bytes: c.datasheet_size_bytes || 0,
      path: `/api/public/pv-components/${c.id}/datasheet?v=${ver(c.datasheet_uploaded_at)}`,
    }));
    const missing = comps.filter((c) => c.type !== "addon" && !c.datasheet_storage_path).map(label);
    return { datasheets, missing };
  }, [items, catalog]);
}
